import React from 'react';
import subscribeForAllUsersThunk from '../../redux/thunks/Users/subscribeForAllUsersThunk';
import { AppState } from '../../redux/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';

interface Props {
    subscribeForAllUsers: () => Promise<void>;
    children: JSX.Element;
}

class Users extends React.PureComponent<Props> {
    public componentDidMount() {
        this.props.subscribeForAllUsers();
    }

    public render() {
        return this.props.children;
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<void, AppState, any>) => ({
    subscribeForAllUsers: async () => {
        await dispatch(subscribeForAllUsersThunk());
    }
});

export default connect(undefined, mapDispatchToProps)(Users);
